import styled, { css } from 'styled-components';
import { ColorAddiGrayLighten1, ColorAddiGrayLighten3, ColorAddiGrayLighten4, ColorAddiWhite, } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightRegular, FontAddiWeightSemiBold } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { Paragraph, SecondaryFont } from '../typographies';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
export const BorderBoxes = css `
  border-width: 1px;
  border-color: ${ColorAddiGrayLighten3};
  border-style: solid;
`;
export const ContainerSearchBar = styled.div `
  position: relative;
`;
export const ContainerSearchBarInput = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 16px;
  gap: 10px;
  background-color: ${ColorAddiGrayLighten4};
  border-radius: 12px;
  position: relative;
  z-index: 5;
  ${BorderBoxes}
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    padding: 16px;
  }
`;
export const SearchIcon = styled.img ``;
export const InputText = styled.input `
  flex: 1;
  height: 24px;
  background-color: transparent;
  border: none;
  outline: none;

  ${SecondaryFont}
  font-weight: ${FontAddiWeightSemiBold};
  font-size: ${SizeAddiFontXSmall};
  line-height: 20.72px;
  ::placeholder {
    font-weight: ${FontAddiWeightRegular};
  }
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 23.68px;
    font-size: ${SizeAddiFontSmall};
  }
`;
export const CleanIcon = styled.img `
  cursor: pointer;
`;
export const ContainerDropdownList = styled.div `
  position: absolute;
  box-sizing: border-box;
  top: 34px;
  padding-top: 34px;
  overflow: hidden;
  width: 100%;

  box-shadow: 0 23px 50px -14px rgb(0 0 0 / 21%);
  border-radius: 13px;
  ${BorderBoxes}
`;
export const DropdownItem = styled.div `
  padding: 8px;
  border-bottom: 1px solid ${ColorAddiGrayLighten3};
  background-color: ${ColorAddiWhite};
  cursor: pointer;
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    padding: 16px 28.3px;
  }
`;
export const DropdownText = styled(Paragraph) `
  margin: 0;
  line-height: 23.68px;
  font-weight: ${FontAddiWeightRegular};
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    color: ${ColorAddiGrayLighten1};
  }
`;
//# sourceMappingURL=searchbar.styled.js.map